import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
 // Ensure this CSS file exists (we'll create it below)

// Placeholder image imports (replace with actual image paths)
import ShashikantImage from '../images/bbb.jpg';
import JitendraImage from '../images/bbb.jpg';
import RaviImage from '../images/bbb.jpg';
import PreetiImage from '../images/aaa.jpg';

interface TeamMember {
  name: string;
  image: string;
  description: string;
}

const CoreTeam: React.FC = () => {
  const teamMembers: TeamMember[] = [
    {
      name: 'Shashikant Mishra',
      image: ShashikantImage,
      description:
        'I have over 15 years of experience in the IT sector and currently serve as a Senior Manager. While my career has equipped me with valuable skills and opportunities, it’s the experiences beyond the corporate world that have truly shaped my perspective. Over the years, I’ve witnessed people facing quiet but deeply meaningful struggles—families doing their best with limited means, children missing out on education due to financial hardship, and individuals enduring health issues without access to proper care. These real-life encounters have inspired me to redirect my focus toward non-profit and community-driven work. I believe it’s time to use my experience, leadership, and resources to serve a greater purpose—supporting and uplifting those who are often overlooked. My journey in the corporate world has prepared me to lead with intention and compassion. Now, I aspire to create meaningful impact at the grassroots level. Our mission is simple yet powerful: no one should go hungry, be denied education, or suffer without support. Through our NGO efforts, we aim to bring hope, dignity, and opportunity to those who need it most.',
    },
    {
      name: 'Jitendra Kumar Yadav',
      image: JitendraImage,
      description:
        'I have over 10 years of experience in the education field, particularly guiding students preparing for civil services. Additionally, I have been involved in the medical field. Through my work, I have witnessed firsthand how people in rural and underprivileged areas struggle to access proper medical care due to financial limitations. This realization deeply moved me and inspired me to dedicate myself to more meaningful work through a non-profit organization (NGO). I believe it is time to use my skills and experience to serve a greater purpose by helping improve the health and well-being of those who need it most.',
    },
    {
      name: 'Ravi Kant Mishra',
      image: RaviImage,
      description:
        'I have more than 10 years of experience in the accounts and finance sector. Additionally, I have worked on a Women Empowerment and Livelihood Program supported by NABARD and implemented by the Ministry of Women and Child Development. Through this experience, I learned how to empower women, particularly those in poor and rural areas, helping them improve their lives. Currently, I am working in the health sector, specifically in the accounts and finance department, under the Ministry of Health and Family Welfare. Over time, I have gained deep insights into how to help the poor and marginalized, especially women, children, and senior citizens, with their health challenges. This realization has driven me to pursue more meaningful work in the non-profit organization (NGO). While I see my current role as a small step in my journey, I know there is so much more to be done. My goal is to focus on areas such as education, health, women empowerment, child care, and humanitarian aid for the hungry. We are not just making an effort; we are starting a revolution. Our mission is to ensure that no one is left hungry, uneducated, powerless, or unhealthy. We are committed to making a real difference in the lives of those in need.',
    },
    {
      name: 'Preeti Yadav',
      image: PreetiImage,
      description:
        'I am an Advocate in The High Court and a dedicated social worker who has worked for 5 years in the field of education and women empowerment. I am interested in bringing positive changes in society and helping weaker sections.',
    },
  ];

  return (
    <section className="core-team-section">
      <Container>
        <h2 className="text-center mb-5 mt-5 core-team-title">Our Core Team</h2>
        {teamMembers.map((member, index) => {
          const isEven = index % 2 === 0;
          const backgroundColor = isEven ? '#f8f9fa' : '#e9ecef'; // Alternating background colors

          return (
            <div
              key={index}
              className="team-member-section mb-5 p-4"
              style={{ backgroundColor }}
            >
              <Row className="align-items-center g-4">
                {isEven ? (
                  <>
                    <Col md={4}>
                      <Image
                        src={member.image}
                        alt={`${member.name}'s profile`}
                        className="team-image img-fluid rounded"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300x300?text=No+Image';
                        }}
                      />
                    </Col>
                    <Col md={8}>
                      <h3 className="team-name">{member.name}</h3>
                      <p className="team-description">{member.description}</p>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md={8}>
                      <h3 className="team-name">{member.name}</h3>
                      <p className="team-description">{member.description}</p>
                    </Col>
                    <Col md={4}>
                      <Image
                        src={member.image}
                        alt={`${member.name}'s profile`}
                        className="team-image img-fluid rounded"
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = 'https://via.placeholder.com/300x300?text=No+Image';
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </div>
          );
        })}
      </Container>
    </section>
  );
};

export default CoreTeam;